export default function ContractIcon({ className="", onClick }) {
  return (
    <>
      <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700">
        <path d="m384.21,101h-211.42c-13.58,0-24.59,11.01-24.59,24.59v448.82c0,13.58,11.01,24.59,24.59,24.59h354.42c13.58,0,24.59-11.01,24.59-24.59v-305.82c0-1.28-.51-2.5-1.41-3.41l-162.77-162.77c-.9-.9-2.13-1.41-3.41-1.41Zm115.21,177.24h-126.78v-126.78l126.78,126.78Zm7.11,275.49H193.47V146.27h133.89v152.68c0,13.54,11.02,24.56,24.56,24.56h154.6v230.22Z"/>
      </svg>
    </>
  );
}